<template>
    <v-layout row wrap>
        <v-flex>
            <div class="text-xs-left">
                <v-btn
                        flat
                        @click="goBack"
                >
                    <v-icon left small>fal fa-chevron-left</v-icon>
                    {{ $vuetify.t('$vuetify.back') }}
                </v-btn>
            </div>
        </v-flex>

        <v-flex xs12 v-if="cartItems.length > 0">
            <h2 class="primary--text" v-if="!showStoreList">
                {{ $vuetify.t('$vuetify.shop.shipping_method') }}
            </h2>


            <v-radio-group
                    class="shop-delivery-choices"
                    :mandatory="true"
                    v-model="selectedDeliveryOption"
                    v-if="!showStoreList">
                <v-list three-line subheader>
                    <div v-for="(option, index) in deliveryOptions"
                         :key="index">
                        <v-list-tile>

                            <v-list-tile-avatar style="border-radius: 0">
                                <v-radio :value=option.identifier></v-radio>
                            </v-list-tile-avatar>

                            <v-list-tile-avatar class="hidden-xs-only" style="border-radius: 0">
                                <OrdersShipment
                                        :shipmentCode=Number(option.identifier)></OrdersShipment>
                            </v-list-tile-avatar>

                            <v-list-tile-content>
                                <v-list-tile-title class="title font-weight-bold">
                                    {{ option.title }}
                                </v-list-tile-title>
                                <v-list-tile-sub-title>
                                    {{ option.text }}
                                </v-list-tile-sub-title>
                                <v-list-tile-title
                                        @click="showStoreList = true"
                                        v-if="Number(option.identifier) === 3 && selectedStore && !showStoreList">
                                    <v-icon class="secondary--text">fal fa-map-pin</v-icon>&nbsp;
                                    <span class="title secondary--text shop-delivery-location pl-2">{{
                                            selectedStore.name
                                        }}</span>
                                </v-list-tile-title>
                            </v-list-tile-content>

                            <v-list-tile-action v-if="option.cost">
                                <v-list-tile-title class="font-weight-bold text-xs-right">
                                    {{ option.cost }}&nbsp;{{ currencySymbol }}
                                </v-list-tile-title>
                            </v-list-tile-action>
                        </v-list-tile>
                    </div>
                </v-list>
            </v-radio-group>

            <v-flex xs12 v-if="!showStoreList">
                <div class="text-xs-center">
                    <v-btn
                            :disabled=!isEnabled
                            @click="submit"
                            class="primary"
                            large
                    >
                        {{ $vuetify.t('$vuetify..shop.shop_cart_checkout') }}
                        <v-icon right small>fal fa-angle-double-right</v-icon>
                    </v-btn>
                </div>
            </v-flex>

            <v-flex xs12 v-if="showStoreList">
                <h2 class="primary--text">
                    {{ $vuetify.t('$vuetify.shop.shipping_location') }}
                </h2>
                <StoresListComp
                        @selected="handleStoreSelected"
                        :displayImage=false
                        :displayGoToDetail=false
                        :select=true
                        :selectedStoreId="selectedStore ? selectedStore.id : selectedStore"
                        :referenceLocation="locationCoords"></StoresListComp>
            </v-flex>
        </v-flex>

        <v-flex xs12 v-else>
            <v-layout align-center justify-center column>
                <v-spacer class="my-4"></v-spacer>
                <v-icon style="font-size: 150px">fal fa-shopping-cart</v-icon>
                <v-spacer class="my-4"></v-spacer>
                <h2 class="title text-xs-center">{{ $vuetify.t('$vuetify.shop.shop_cart_empty') }}</h2>
                <v-spacer class="my-4"></v-spacer>
                <div class="text-xs-center">
                    <v-btn
                            @click="goTo"
                            class="primary"
                            large
                    >
                        {{ $vuetify.t('$vuetify.shop.buy') }}
                        <v-icon right small>fal fa-angle-double-right</v-icon>
                    </v-btn>
                </div>
            </v-layout>
        </v-flex>
    </v-layout>
</template>


<script>
import {mapGetters} from 'vuex';
import {genericService} from '@/_services/shop/generic.service';
import {getErrorMessage, getLocation, recaptchaHelper} from '@/_helpers';
import StoresListComp from '@/components/StoresListComp.vue';
import OrdersShipment from '@/components/shop/OrdersShipment.vue';

export default {
    name: "DeliveryOptions",
    components: {StoresListComp, OrdersShipment},
    data() {
        return {
            selectedStore: null,
            deliveryOptions: [],
            selectedDeliveryOption: null,
            showStoreList: false,
            dataReady: false,
            locationCoords: null
        }
    },
    methods: {
        /**
         * The method which sends to the backend the necessary data to create the Order.
         **/
        submit() {
            // 1 - setting the Loading Layer
            this.$store.dispatch("loader/setLoading", true);

            // 2 - an object is defined with all the information which will be passed to the backend
            let obj = {
                "items": this.cartItems,
                "shipping_pickup_store": this.selectedStore.code
            };

            // 3 - the backend will validate if the chosen Items are available on the selected Store
            recaptchaHelper('validateCustomerPurchase', this).then((token) => {
                    obj.recaptcha_token = token;
                    genericService.validateCustomerPurchase(obj).then(result => {
                            this.$store.dispatch('shop/setShopCart', result);
                            this.$store.dispatch("loader/setLoading", false);
                        },
                        error => {
                            getErrorMessage(error, 'Set Customer Purchase', this);
                        });
                },
                error => {
                    getErrorMessage(error, 'Validate Customer Purchase Recaptcha', this);
                });

            // 4 - setting the selected Store to collect the Order on the Local Storage;
            // The Store is stored "complete" because during the following interfaces, it is necessary to display,
            // for example, the name of the Store.
            let selectedOption = this.deliveryOptions.find(item => item.identifier === this.selectedDeliveryOption)
            if (selectedOption) {
                this.$store.dispatch("shop/setDeliveryOptions", {
                    'methodKey': this.selectedDeliveryOption,
                    'methodTitle': selectedOption.title,
                    'shop': this.selectedStore
                });
            }

            // 5 - changing to the interface where the user can check the Order before submitting it
            this.$router.push({name: "order-resume"});
        },
        /**
         * The Delivery option "Store Pick Up" requires the user to select a Store to collect the Order.
         * This method is called when the user selects the Store. This way, a local variable is set with the
         * selected Store.
         * Also the flag to display/hide the list of Stores is set to False, so the list is set to hidden.
         **/
        handleStoreSelected(store) {
            this.selectedStore = store;
            this.showStoreList = false;
        },
        /**
         * The method assigned to the button which is displayed once the Shopping Cart is empty. This button
         * redirects the user to the Catalog
         **/
        goTo() {
            this.$router.push({name: "catalog"});
        },
        /**
         * The method assigned to the button which allows the user to return to the interface to choose the
         * Delivery Options
         **/
        goBack() {
            this.$router.push({name: "order-cart"});
        },
    },
    computed: {
        /**
         * The button which allows the user to go to the "Resume" of the order, should be disabled until the user
         * selects the Store where the Order will be collected.
         * @returns {boolean}
         */
        isEnabled() {
            if (this.selectedDeliveryOption) {
                if (this.selectedDeliveryOption === "3" && this.selectedStore) {
                    return true;
                } else if (this.selectedDeliveryOption !== "3") {
                    return true;
                }
            }

            return false
        },
        ...mapGetters({
            cartItems: 'shop/cartItems',
            cartTotalItems: 'shop/cartSize',
            cartTotalAmount: 'shop/cartTotalAmount',
            deliveryInfo: 'shop/deliveryInfo',
            currencySymbol: 'configs/currencySymbol',
        })
    },
    watch: {
        /**
         * This function handles the display/hide of the list of Stores the user might have to select if the
         * option Store Pick Up is selected
         * @param option
         * @param oldOption
         */
        selectedDeliveryOption: function (option, oldOption) {
            if (this.dataReady) {
                this.$store.dispatch("loader/setLoading", true);
                this.$log.debug("The selected delivery option is " + option);
                if (option === "3" && option !== oldOption) {
                    this.showStoreList = true;
                }
                this.$store.dispatch("loader/setLoading", false);
            }

        }
    },
    mounted() {
        this.$store.dispatch("loader/setLoading", true);

        genericService.getDeliveryOptions().then(result => {
                this.deliveryOptions = result.results[0].delivery_options;
                this.$store.dispatch("loader/setLoading", false);
            },
            error => {
                getErrorMessage(error, 'Getting the Delivery Options', this);
            }
        );

        if (this.deliveryInfo && this.deliveryInfo.method_key) {
            this.selectedDeliveryOption = this.deliveryInfo.method_key;
            if (this.deliveryInfo.method_key === "3") {
                this.selectedStore = this.deliveryInfo.store
            }
        }
        //with this we skip the first onChange which triggers the flag showStoreList to be set to True
        this.$nextTick(() => {
            this.dataReady = true
        });

        //https://developer.mozilla.org/pt-BR/docs/Web/API/Position
        //Getting user's current geo location
        if (navigator.geolocation) {
            this.locationCoords = getLocation(navigator.geolocation);
        }
    }
}
</script>

<style scoped>

</style>